import { SiteEventType, Species } from "../api/dtos/dtos";

const images = import.meta.glob(
    "../assets/images/notifications/*.{png,jpg,jpeg,svg}",
    {
        eager: true,
        import: "default",
    }
) as Record<string, string>;

const getImage = (fileName: string): string =>
    images[`../assets/images/notifications/${fileName}`] ??
    images["../assets/images/notifications/feralscan_map.png"];

export default function getNotificationImage(
    species?: Species,
    siteEventType?: SiteEventType
): string {
    const imageMap: Partial<
        Record<Species, Partial<Record<SiteEventType, string>> & { default: string }>
    > = {
        [Species.Rabbit]: {
            [SiteEventType.Disease]: "alert_rabbit_orange.png",
            [SiteEventType.Sighting]: "alert_rabbit_green.png",
            [SiteEventType.Damage]: "alert_rabbit_red.png",
            [SiteEventType.Control]: "alert_rabbit_blue.png",
            default: "Rabbit.png",
        },

        [Species.Fox]: {
            [SiteEventType.Sighting]: "alert_fox_green.png",
            [SiteEventType.Damage]: "alert_fox_red.png",
            [SiteEventType.Control]: "alert_fox_blue.png",
            default: "Fox.png",
        },

        [Species.Camel]: {
            [SiteEventType.Sighting]: "alert_other_pests_camel_green.png",
            [SiteEventType.Damage]: "alert_other_pests_camel_red.png",
            [SiteEventType.Control]: "alert_other_pests_camel_blue.png",
            default: "Camel.png",
        },

        [Species.FeralPig]: {
            [SiteEventType.Sighting]: "alert_pig_green.png",
            [SiteEventType.Damage]: "alert_pig_red.png",
            [SiteEventType.Control]: "alert_pig_blue.png",
            default: "FeralPig.png",
        },

        [Species.Myna]: {
            [SiteEventType.Sighting]: "alert_myna_green.png",
            [SiteEventType.Damage]: "alert_myna_red.png",
            [SiteEventType.Control]: "alert_myna_blue.png",
            default: "Myna.png",
        },

        [Species.WildDog]: {
            [SiteEventType.Sighting]: "alert_dog_green.png",
            [SiteEventType.Damage]: "alert_dog_red.png",
            [SiteEventType.Control]: "alert_dog_blue.png",
            default: "WildDog.png",
        },

        [Species.Toad]: {
            [SiteEventType.Sighting]: "alert_toad_green.png",
            [SiteEventType.Damage]: "alert_toad_red.png",
            [SiteEventType.Control]: "alert_toad_blue.png",
            default: "Toad.png",
        },

        [Species.FeralGoat]: {
            [SiteEventType.Sighting]: "alert_goat_green.png",
            [SiteEventType.Damage]: "alert_goat_red.png",
            [SiteEventType.Control]: "alert_goat_blue.png",
            default: "FeralGoat.png",
        },

        [Species.Starling]: {
            [SiteEventType.Sighting]: "alert_starling_green.png",
            [SiteEventType.Damage]: "alert_starling_red.png",
            [SiteEventType.Control]: "alert_starling_blue.png",
            default: "Starling.png",
        },

        [Species.Deer]: {
            [SiteEventType.Sighting]: "alert_deer_green.png",
            [SiteEventType.Damage]: "alert_deer_red.png",
            [SiteEventType.Control]: "alert_deer_blue.png",
            default: "Deer.png",
        },

        [Species.FeralFish]: {
            [SiteEventType.Sighting]: "alert_fish_green.png",
            [SiteEventType.Damage]: "alert_fish_red.png",
            [SiteEventType.Control]: "alert_fish_blue.png",
            default: "FeralFish.png",
        },

        [Species.Mouse]: {
            [SiteEventType.Sighting]: "alert_mouse_green.png",
            [SiteEventType.Damage]: "alert_mouse_red.png",
            [SiteEventType.Control]: "alert_mouse_blue.png",
            default: "Mouse.png",
        },

        [Species.FeralCat]: {
            [SiteEventType.Sighting]: "alert_cat_green.png",
            [SiteEventType.Damage]: "alert_cat_red.png",
            [SiteEventType.Control]: "alert_cat_blue.png",
            default: "FeralCat.png",
        },

        [Species.NewPests]: {
            [SiteEventType.Sighting]: "alert_new_pests_green.png",
            [SiteEventType.Damage]: "alert_new_pests_red.png",
            [SiteEventType.Control]: "alert_new_pests_blue.png",
            default: "NewPests.png",
        },

        [Species.OtherPests]: {
            [SiteEventType.Sighting]: "alert_other_pests_donkey_green.png",
            [SiteEventType.Damage]: "alert_other_pests_donkey_red.png",
            [SiteEventType.Control]: "alert_other_pests_donkey_blue.png",
            default: "portrait_otherpests_web.png",
        },
    };

    const speciesImages = imageMap[species!];

    if (!speciesImages) {
        return getImage("feralscan_map.png");
    }

    return getImage(
        speciesImages[siteEventType!] ?? speciesImages.default
    );
}